import { Badge } from '@/components/ui/Badge';

const statusMap: Record<string, { variant: 'success' | 'warning' | 'error' | 'info' | 'default'; label: string }> = {
  open: { variant: 'info', label: 'Open' },
  in_progress: { variant: 'warning', label: 'In Progress' },
  waiting_customer: { variant: 'default', label: 'Waiting Customer' },
  waiting_internal: { variant: 'default', label: 'Waiting Internal' },
  resolved: { variant: 'success', label: 'Resolved' },
  closed: { variant: 'default', label: 'Closed' },
};

interface Props {
  status: string;
}

export function TicketStatusBadge({ status }: Props) {
  const config = statusMap[status] || { variant: 'default' as const, label: status };
  return <Badge variant={config.variant}>{config.label}</Badge>;
}
